import { render } from "./VendorServiceItemModal.vue?vue&type=template&id=1473c8f0"
import script from "./VendorServiceItemModal.vue?vue&type=script&lang=js"
export * from "./VendorServiceItemModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__